var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.74931 15.74931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 15.74931,
    height: 15.74931,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.31214,1.74928a.437.437,0,0,1,.3.123.404.404,0,0,1,.137.315v9.46a.8515.8515,0,0,1-.15.493.93.93,0,0,1-.397.328l-4.155,1.45a1.8709,1.8709,0,0,1-1.094,0l-4.703-1.669-4.648,1.723a.51611.51611,0,0,1-.164.027.44.44,0,0,1-.301-.123.404.404,0,0,1-.137-.314v-9.461a.85063.85063,0,0,1,.15-.492.93.93,0,0,1,.397-.328l4.156-1.45a1.86545,1.86545,0,0,1,1.094,0l4.703,1.668,4.649-1.722a.51606.51606,0,0,1,.164-.028Zm-14.465,2.352.027,8.832,3.938-1.45v-8.75l-3.965,1.369Zm4.84,7.383,4.375,1.531v-8.75l-4.375-1.531Zm5.25,1.531,3.964-1.367-.027-8.832-3.937,1.449Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ae1b2ffd7e9898fe8d3dcbbc4c98ad17.svg";
export { ForwardRef as ReactComponent };